import { Card, styled } from '@healthinal/ui';
import { theme } from '../theme.ts';

export const SubCard = styled(Card)`
  background-color: ${theme.vars.palette.background.level2};
`;
